import { PropsWithChildren, ReactElement } from "react";
import styles from "./FrequentlyUsedTileVisualList.module.less";

export const FrequentlyUsedTileVisualList = (
	props: PropsWithChildren<{}>
): ReactElement => {
	const {
		children
	} = props;

	return (
		<ul className={styles.root}>
			{children}
		</ul>
	);
};
FrequentlyUsedTileVisualList.displayName = "FrequentlyUsedTileVisualList";

const FrequentlyUsedTileVisualListItem = (
	props: PropsWithChildren<{}>
): ReactElement => {
	const {
		children
	} = props;

	return (
		<li>
			{children}
		</li>
	);
};
FrequentlyUsedTileVisualListItem.displayName = "FrequentlyUsedTileVisualListItem";

FrequentlyUsedTileVisualList.Item = FrequentlyUsedTileVisualListItem;